 


import React, { useState } from "react";
import "../src/Signup.css";  

const Register = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    mobileNumber: "",
    referralCode: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.fullName) newErrors.fullName = "The full name field is required.";
    if (!formData.mobileNumber) newErrors.mobileNumber = "The phone number field is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      console.log("Form Submitted", formData);
    }
  };

  return (
  <>
  <div className="container-fluid mt-5 pt-3"  style={{height:'90vh', overflow:'hidden'}} >
    <div className="row">
        <div className="col-lg-12 col-sm-12">

        <div className="signup-container  pt-5 h-100 ">
      <h2 className="text-white">Sign Up</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="fullName">
            <i className="icon-user"></i>
          </label>
          <input
            type="text"
            id="fullName"
            name="fullName"
            placeholder="Full Name"
            value={formData.fullName}
            onChange={handleChange}
          />
          {errors.fullName && <span className="error">{errors.fullName}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="mobileNumber">
            <i className="icon-phone"></i>
          </label>
          <input
            type="text"
            id="mobileNumber"
            name="mobileNumber"
            placeholder="Mobile Number"
            value={formData.mobileNumber}
            onChange={handleChange}
          />
          {errors.mobileNumber && <span className="error">{errors.mobileNumber}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="referralCode">
            <i className="icon-gift"></i>
          </label>
          <input
            type="text"
            id="referralCode"
            name="referralCode"
            placeholder="Enter Referral Code"
            value={formData.referralCode}
            onChange={handleChange}
          />
        </div>

        <button type="submit" className="submit-button">Submit</button>
      </form>

      <p className="signin-text">
        Already have an account? <a href="/signin">Sign in</a>
      </p>

      <p className="terms-text">
        By proceeding, you agree to our <a href="#">Terms of Use</a>, <a href="#">Privacy Policy</a> 
        and that you are 18 years or older. You are not playing from Assam, Odisha, Nagaland, Sikkim, Meghalaya, Andhra Pradesh, or Telangana.
      </p>
    </div>
        </div>
    </div>
  </div>
  </>
  );
};

export default Register;
